import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { HoslogRequestPlans } from './hoslog-plans-request.types';
import { planParams } from './hoslog-plans.queries';
import { StatusType } from './hoslog-plans.types';

type TimeIntervalItem = {
  timeInterval: string;
};

type TimeIntervalList = TimeIntervalItem[];

export const getPlansRequest = (client: AxiosInstance) => async (params?: planParams) => {
  return (await client.get<PaginatedApiResponse<HoslogRequestPlans[]>>(API_ROUTES.GET_PLAN_REQUEST, { params })).data;
};

export const getPlanRequestById = (client: AxiosInstance) => async (planId: string, clubId: string) => {
  return (
    await client.get<{ message: string; data: HoslogRequestPlans }>('/get-plan-request-detail', {
      params: { planId, clubId },
    })
  ).data;
};

export const getTimeInterval = (client: AxiosInstance) => async (clubId: string) => {
  return (await client.get<ApiResponse<TimeIntervalList>>('/get-time-interval', { params: { clubId } })).data;
};

export const hoslogPlanRequestQueries = {
  all: () => ['hoslog-plans-request'],
  list: (type: StatusType, params?: planParams) =>
    queryFactoryOptions<PaginatedApiResponse<HoslogRequestPlans[]>>({
      queryKey: [...hoslogPlanRequestQueries.all(), 'list', type, params],
      queryFn: (client) => () => getPlansRequest(client)(params),
    }),
  details: (planId: string, clientId: string) =>
    queryFactoryOptions<{ message: string; data: HoslogRequestPlans }>({
      queryKey: [...hoslogPlanRequestQueries.all(), 'details', planId, clientId],
      queryFn: (client) => () => getPlanRequestById(client)(planId, clientId),
    }),
  getTimeInterval: (clientId: string) =>
    queryFactoryOptions<ApiResponse<TimeIntervalList>>({
      queryKey: [...hoslogPlanRequestQueries.all(), 'getTimeInterval', clientId],
      queryFn: (client) => () => getTimeInterval(client)(clientId),
    }),
};
